export const apiUrl = process.env.API_URL || "http://localhost:4001";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
